import React from "react";

import { Button, Col, Modal, Row } from "react-bootstrap";

const ModalWarning = ({ show, handleClose, closeAll }) => {
  return (
    <Modal show={show} onHide={handleClose} centered id="modal-warning">
      <Modal.Body>
        <p className="parrafo-modal text-center">Si cerras esta pestaña no podremos enviar tu consulta.</p>

        <Row>
          <Col md={6} className="pb-3">
            <Button type="button" className="btn-blue w-100 btn-enviar-formulario" onClick={() => closeAll()}>
              Cerrar
            </Button>
          </Col>
          <Col md={6} className="pb-3">
            <Button type="button" className="btn-blue w-100 btn-default mt-4" onClick={() => handleClose()}>
              Continuar
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ModalWarning;
